import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

export default function PricingHero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-deepblack"
    >
      {/* Ambient background glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-champagne/5 blur-[120px]" />
      </div>

      <Reveal>
        <div className="relative z-10 w-full px-6 md:px-12 lg:px-16 text-center">
          {t("pricing.hero.tag") && (
            <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-10"
            >
              {t("pricing.hero.tag")}
            </span>
          )}

          {/* Zero to One branding */}
          <div className="mb-6">
            <h2 className="font-serif text-marble leading-none flex flex-wrap items-center justify-center gap-3 md:gap-5">
              <span className="text-5xl md:text-7xl lg:text-8xl font-light tracking-wide">
                {t("pricing.hero.brand2")}
              </span>
              <span className="text-xl md:text-3xl lg:text-4xl font-light tracking-widest text-champagne">
                {t("pricing.hero.brand3")}
              </span>
              <span className="text-5xl md:text-7xl lg:text-8xl font-light tracking-wide">
                {t("pricing.hero.brand4")}
              </span>
            </h2>
          </div>

          {/* Description below Zero to One */}
          <div className="mb-8">
            <p className="text-marble/80 text-sm md:text-base font-sans leading-relaxed text-center max-w-2xl mx-auto whitespace-pre-line">
              <span className="md:hidden">{t("pricing.hero.descriptionMobile")}</span>
              <span className="hidden md:inline">{t("pricing.hero.description")}</span>
            </p>
          </div>

          {/* Program label — smaller text */}
          <div className="relative inline-block bg-champagne/10 rounded-2xl border border-champagne/40 px-6 md:px-10 py-4 md:py-5">
            <p className="text-champagne font-serif text-sm md:text-lg lg:text-xl font-light tracking-wide leading-relaxed max-w-3xl whitespace-pre-line">
              <span className="md:hidden">{t("pricing.hero.programLabelMobile")}</span>
              <span className="hidden md:inline">{t("pricing.hero.programLabel")}</span>
            </p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}